var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50016 12.6666C10.6298 12.6666 13.1668 10.1295 13.1668 6.99992C13.1668 3.87032 10.6298 1.33325 7.50016 1.33325C4.37056 1.33325 1.8335 3.87032 1.8335 6.99992C1.8335 10.1295 4.37056 12.6666 7.50016 12.6666Z",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38549 4.78103C8.90292 4.29847 8.23626 4 7.49986 4C6.76349 4 6.09682 4.29847 5.61426 4.78103",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5737 11.074L14.4022 13.9024",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.92f9dccdaad101a38e1f8254d0e81601.svg";
export { ForwardRef as ReactComponent };